import React from 'react';
import { PropTypes } from 'prop-types';
import { Row, InfoContainer, MobileSpacer, FormElements, Grid, Text } from '@custom-components';
import { StyledInfoContainer, StyledContainer } from '../Steps.styles';

function ConnectionReview(props) {
  const { mainForm } = props;

  const loadAttributes = () => {
    const attributes = mainForm.values.connectionAttributes;

    // Check for extra configuration
    if (Object.keys(attributes).length > 0) {
      return Object.keys(attributes).map((key, index) => {
        // Insert a space before each Capital Letter
        const label = key.replace(/([A-Z])/g, ' $1').trim();

        switch (attributes[key].formElement.toLowerCase()) {
          case 'select':
            return (
              <Grid.Col lg={12} style={{ marginTop: index === 0 ? '1%' : '4%' }}>
                <FormElements.Select
                  variant="outlined"
                  id={`Attribute${attributes[key].formElement}-${index}`}
                  key={`Attribute${attributes[key].formElement}-${key}`}
                  name={`Attribute${attributes[key].formElement}-${index}`}
                  label={label}
                  value={attributes[key].label}
                  options={[
                    {
                      label: attributes[key].label,
                      value: attributes[key].label
                    }
                  ]}
                  inputProps={{ readOnly: true }}
                  disabled
                />
              </Grid.Col>
            );

          case 'auto':
            // eslint-disable-next-line no-case-declarations
            const elementName = attributes[key].complement.name.replaceAll(/\s/g, '');
            return (
              <>
                <Grid.Col sm={12} md={6} style={{ marginTop: index === 0 ? '1%' : '3%' }}>
                  <FormElements.TextInput
                    name={`Attribute${attributes[key].formElement}-${elementName}${index}`}
                    key={`Attribute${attributes[key].formElement}-${elementName}${key}`}
                    label={attributes[key].complement.name}
                    value={attributes[key].complement.value}
                    InputProps={{ readOnly: true }}
                    disabled
                  />
                </Grid.Col>
                <MobileSpacer lessThan="md" />
                <Grid.Col sm={12} md={6} style={{ marginTop: index === 0 ? '1%' : '3%' }}>
                  <FormElements.TextInput
                    name={`Attribute${attributes[key].formElement}-${index}`}
                    key={`Attribute${attributes[key].formElement}-${key}`}
                    label={label}
                    value={attributes[key].value}
                    InputProps={{ readOnly: true }}
                    disabled
                  />
                </Grid.Col>
              </>
            );

          // TextInput
          default:
            return (
              <Grid.Col lg={12} style={{ marginTop: index === 0 ? '1%' : '3%' }}>
                <FormElements.TextInput
                  name={`Attribute${attributes[key].formElement}-${index}`}
                  key={`Attribute${attributes[key].formElement}-${key}`}
                  label={label}
                  value={attributes[key].value}
                  InputProps={{ readOnly: true }}
                  disabled
                />
              </Grid.Col>
            );
        }
      });
    }

    return (
      <div style={{ marginLeft: '2%' }}>
        <Text.CopyParagraph>This Connection does not need any extra configuration attributes.</Text.CopyParagraph>
      </div>
    );
  };

  const loadReviewConnection = () => (
    <StyledInfoContainer>
      <StyledContainer>
        <Row>
          <Grid.Col lg={12} style={{ marginTop: '1%' }}>
            <FormElements.Select
              variant="outlined"
              id="connectionType"
              key="connectionType"
              name="connectionType"
              label="Connection Type"
              value={mainForm.values.connectionType}
              options={[
                {
                  label: mainForm.values.connectionType,
                  value: mainForm.values.connectionType
                }
              ]}
              inputProps={{ readOnly: true }}
              disabled
            />
          </Grid.Col>
          <Grid.Col lg={12} style={{ marginTop: '3%' }}>
            <FormElements.Select
              variant="outlined"
              id="connectionProvider"
              key="connectionProvider"
              name="connectionProvider"
              label="Connection Provider"
              value={mainForm.values.connectionProvider}
              options={[
                {
                  label: mainForm.values.connectionProvider,
                  value: mainForm.values.connectionProvider
                }
              ]}
              inputProps={{ readOnly: true }}
              disabled
            />
          </Grid.Col>
          <Grid.Col lg={12} style={{ marginTop: '3%' }}>
            <InfoContainer leftSubBarContents={[{ type: 'label', props: { label: 'Connection Attributes' } }]}>
              <Row>{loadAttributes()}</Row>
            </InfoContainer>
          </Grid.Col>
        </Row>
      </StyledContainer>
    </StyledInfoContainer>
  );

  return <div style={{ marginTop: '5%' }}>{loadReviewConnection()}</div>;
}

ConnectionReview.propTypes = {
  mainForm: PropTypes.shape({
    values: {
      connectionType: PropTypes.string,
      connectionProvider: PropTypes.string,
      connectionAttributes: PropTypes.shape({})
    }
  })
};

ConnectionReview.defaultProps = {
  mainForm: {}
};

export default ConnectionReview;
